import React, { SVGProps } from 'react';

const NewsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.58325 11.4683L10.1616 14.94C10.3491 16.0675 9.47992 17.0933 8.33742 17.0933V17.0933C7.43325 17.0933 6.66159 16.44 6.51325 15.5475L5.83325 11.4683"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4583 11.4683H4.89575C3.34242 11.4683 2.08325 10.2092 2.08325 8.65582V8.65582C2.08325 7.10249 3.34242 5.84332 4.89575 5.84332H11.4583"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4583 5.84333L15.6258 3.06499C16.2491 2.64999 17.0833 3.09666 17.0833 3.84583V13.4667C17.0833 14.2158 16.2491 14.6617 15.6258 14.2467L11.4583 11.4683"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.4582 11.4667V5.84167"
        stroke="white"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NewsIcon;
